import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-attachment-icon',
  templateUrl: './communication-mail-attachment.component.html'
})
export class CommunicationMailAttachmentComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
